import React, { useState, useEffect } from 'react';
import { sectors, equipmentCategories } from '../data/ServiceLists';
import { CaretDown, CheckCircle } from "@phosphor-icons/react";

const ServiceScope = () => {
    const [activeTab, setActiveTab] = useState('sectores');
    const [openIndex, setOpenIndex] = useState(null); // Para controlar cuál está abierto

    // Resetear el acordeón cuando cambies de pestaña
    useEffect(() => {
        setOpenIndex(null);
    }, [activeTab]);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const currentList = activeTab === 'sectores' ? sectors : equipmentCategories;

    return (
        <section className="py-20 bg-gray-50/50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16" data-aos="fade-up">
                    <h2 className="text-3xl md:text-4xl font-bold text-ctex-blue mb-4 uppercase italic">
                        Alcance de Servicio Especializado
                    </h2>
                    <p className="text-gray-500 max-w-3xl mx-auto text-sm italic">
                        Soluciones integrales para entornos comerciales e industriales.
                    </p>
                </div>

                {/* Tabs Selector */}
                <div className="flex justify-center mb-12" data-aos="fade-up">
                    <div className="inline-flex p-1.5 bg-white rounded-3xl border border-gray-200 shadow-sm">
                        <button
                            onClick={() => setActiveTab('sectores')}
                            className={`px-8 py-3 rounded-2xl text-xs font-black uppercase tracking-widest transition-all duration-300 ${activeTab === 'sectores' ? 'bg-ctex-blue text-white shadow-xl scale-105' : 'text-gray-400 hover:text-gray-600'}`}
                        >
                            Sectores
                        </button>
                        <button
                            onClick={() => setActiveTab('equipos')}
                            className={`px-8 py-3 rounded-2xl text-xs font-black uppercase tracking-widest transition-all duration-300 ${activeTab === 'equipos' ? 'bg-ctex-blue text-white shadow-xl scale-105' : 'text-gray-400 hover:text-gray-600'}`}
                        >
                            Equipos de atención
                        </button>
                    </div>
                </div>

                {/* Grid con altura controlada para evitar saltos bruscos */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-start" data-aos="fade-up">
                    {currentList.map((cat, idx) => (
                        <div
                            key={`${activeTab}-${idx}`}
                            className={`bg-white rounded-3xl border transition-all duration-300 overflow-hidden shadow-sm ${openIndex === idx ? 'ring-2 ring-ctex-orange/30 border-ctex-orange/20 shadow-md' : 'border-gray-100 hover:border-gray-200'}`}
                        >
                            <button
                                onClick={() => toggleAccordion(idx)}
                                className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
                            >
                                <div className="flex items-center gap-4">
                                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-colors duration-300 ${openIndex === idx ? 'bg-ctex-orange text-white' : 'bg-gray-50 text-ctex-blue'}`}>
                                        {React.cloneElement(cat.icon, { size: 24, weight: "duotone" })}
                                    </div>
                                    <span className={`font-bold text-sm uppercase tracking-tight transition-colors ${openIndex === idx ? 'text-ctex-blue' : 'text-gray-700'}`}>
                                        {cat.title}
                                    </span>
                                </div>
                                <CaretDown
                                    size={20}
                                    className={`transition-transform duration-500 ${openIndex === idx ? 'rotate-180 text-ctex-orange' : 'text-gray-400'}`}
                                />
                            </button>

                            {/* Contenido animado */}
                            <div className={`transition-all duration-500 ease-in-out ${openIndex === idx ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}`}>
                                <div className="px-6 pb-6 pt-2 border-t border-gray-50 bg-gray-50/30">
                                    <ul className="space-y-2 mt-4">
                                        {cat.items.map((item, i) => (
                                            <li key={i} className="flex items-start gap-3 text-xs text-gray-500 italic leading-relaxed">
                                                <CheckCircle size={14} weight="fill" className="text-ctex-orange/50 mt-0.5 shrink-0" />
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceScope;